import React from 'react';
import { toHtml } from '../richText.js';

// Formatted text from the content editor (sanitized by the server; older
// plain text is shown as paragraphs, line by line).
export default function RichText({ value, className = '', ...rest }) {
  const html = toHtml(value);
  if (!html) return null;
  return <div className={`rich-text ${className}`.trim()} dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
}
